import { useEffect, useMemo, useState } from "react";
import Table from "../../../Common/Table";
import Pagination from "../../../Common/Pagination";
import icons from "../../../../assets/images/constantIcons";
import apiService, { handleError } from "../../../Common/ApiCommon/ApiService";


const CollectionReports = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [collectionData, setCollectionData] = useState(null);
    const [collectionLoading, setCollectionLoading] = useState(false);

    const fetchCollectionReport = async () => {
        setCollectionLoading(true);
        try {
            const response = await apiService.get(`/canteen_orders/collection_report`);
            setCollectionData(response);
        } catch (error) {
            handleError(error);
        } finally {
            setCollectionLoading(false);
        }
    };

    useEffect(() => {
        fetchCollectionReport();
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Total Collection",
                accessor: "totalCollection",
                Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
            },
            // {
            //     Header: "Closing Time",
            //     accessor: "closingTime",
            // },
            {
                Header: "Cash Collection",
                accessor: "cashCollection",
            },
            {
                Header: "UPI Collection",
                accessor: "upiCollection",
            },
            // {
            //     Header: "Expenses",
            //     accessor: "expenses",
            // },
        ],
        []
    );

    const data = collectionData?.length
        ? collectionData.map((item) => ({
            orderId: item.order_id,
            totalCollection: `₹ ${item.total_collection}`,
            cashCollection: `₹ ${item.cash_collection}`,
            upiCollection: `₹ ${item.upi_collection}`,
            expenses: `₹ ${item.expenses}`,
        }))
        : [];


    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    return (
        <div className="flex flex-col p-4">
            <div className="flex justify-between items-center mb-3">
                <h1 className="main_heading text-lg sm:text-[22px] flex gap-3 items-center">
                    Collection Report
                </h1>
            </div>

            {collectionLoading ? (
                <div className="flex justify-center items-center my-4">
                    <p className="text-green700 font-medium">Loading data...</p>
                </div>
            ) : (
                <div className="my-2 mb-6 overflow-auto vertical max-h-[70vh] horizontalscroll">
                    <Table columns={columns} data={currentRows} />
                </div>
            )}

            <Pagination
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalRows={data.length}
                onPageChange={setCurrentPage}
                onRowsPerPageChange={(newRows) => {
                    setRowsPerPage(newRows);
                    setCurrentPage(1);
                }}
            />
        </div>
    );
};

export default CollectionReports;
